const state = {
  chatList: []
}

const getters = {

}

const mutations = {
  setUnread(state, value) {
    const _dataArr = state.chatList
    _dataArr.forEach(val => {
      if (val.buyer_uid == value.userId) {
        val.unread = value.unread
      }
    })
  },
  setChatList(state, value) {
    state.chatList = value
  },
  addMsg(state, value) {
    const _dataArr = state.chatList
    _dataArr.forEach((val) => {
      if (val.buyer_uid == value.user.userId) {
        if (val.msg.length > 50) {
          val.msg.shift()
        }
        val.msg.push(value)
      }
    })

    state.chatList = _dataArr
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
